import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';

const MessagesList = ({ messages, maxVisible = 4 }) => {

  const theme = useTheme();
  const getVisibleMessages = () => {
    if (!messages || messages.length === 0) {
      return [];
    }
    
    const visibleCount = Math.min(messages.length, maxVisible);
    const recentMessages = messages.slice(-visibleCount);
    
    return recentMessages.map((message, index) => {
      const opacity = messages.length === 1 
        ? 1.0 
        : 0.2 + (index * (0.8 / (visibleCount - 1 || 1)));
      
      const uniqueKey = `message-${index}`;
      
      return (
        <Typography 
          key={uniqueKey}
          sx={{
            opacity,
            color: theme.palette.primary.light,
            fontSize: 14,
            fontWeight: index === visibleCount - 1 ? 400 : 300, // Make newest message slightly bolder
            transition: 'opacity 0.3s ease',
            mb: 3,
            lineHeight: 1.5,
            textAlign: 'center',
          }}
        >
          {message}
        </Typography>
      );
    });
  };

  return (
    <Box 
      sx={{ 
        width: '100%', 
        display: 'flex',
        flexDirection: 'column',
        flexFlow: 'column-reverse',
        justifyContent: 'flex-end',
        minHeight: maxVisible * 30, // Approximate height for N messages
      }}
    >
      {getVisibleMessages()}
    </Box>
  );
};

export default MessagesList; 